import { useTrackEvent } from "@outschool/ui-analytics";
import { TopicPill } from "@outschool/ui-components-website";
import { Carousel } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

type TutoringSubcategoriesProps = {
  subcategories: Array<{ nameTitleCased: string; slug: string }>;
  selectedSubcategory: string;
  setSubcategory: (a: string) => void;
};

const TutoringSubcategories: React.FC<TutoringSubcategoriesProps> = props => {
  const { subcategories, selectedSubcategory, setSubcategory } = props;
  const isMobile = useIsMobile();
  const trackEvent = useTrackEvent();
  return (
    <Carousel
      sx={{
        fontSize: "small",
        marginX: isMobile ? "-1em" : 0,
        "a:hover": { textDecoration: "none" },
        overflow: "auto"
      }}
      innerSx={{
        justifyContent: "flex-start",
        gap: "small",
        paddingLeft: isMobile ? "1em" : 2,
        paddingRight: isMobile ? "1em" : 2,
        paddingTop: "2px",
        paddingBottom: "2px"
      }}
    >
      {subcategories.map(({ nameTitleCased: name, slug }, index) => (
        <TopicPill
          key={index}
          isActive={selectedSubcategory === slug}
          onClick={(e: React.SyntheticEvent) => {
            e.preventDefault();
            setSubcategory(slug);
            trackEvent("tutoring_page_subcategory_click", {
              subcategory_slug: slug,
              order: index
            });
          }}
        >
          {name}
        </TopicPill>
      ))}
    </Carousel>
  );
};

export default TutoringSubcategories;
